import React from "react";
import { Alert, Button, Spin } from "antd";

// Shared loading/error states for the Dashboard cards so the three cards
// render failures and spinners consistently.

interface CardLoadingProps {
  // Optional Spin tip (e.g. "Analizando programas…").
  tip?: string;
}

export const CardLoading: React.FC<CardLoadingProps> = ({ tip }) => (
  <div style={{ textAlign: "center", padding: "24px 0" }}>
    {tip ? (
      <Spin tip={tip}>
        <div style={{ minHeight: 80 }} />
      </Spin>
    ) : (
      <Spin />
    )}
  </div>
);

interface CardErrorProps {
  message: string;
  onRetry: () => void;
}

export const CardError: React.FC<CardErrorProps> = ({ message, onRetry }) => (
  <Alert
    type="error"
    showIcon
    message={message}
    action={
      <Button size="small" onClick={onRetry}>
        Reintentar
      </Button>
    }
  />
);
